/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersnotfound2Inputs */

const en_partnersnotfound2 = /** @type {(inputs: Partnersnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This partner does not exist.`)
};

const de_partnersnotfound2 = /** @type {(inputs: Partnersnotfound2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Partner gibt es nicht.`)
};

/**
* | output |
* | --- |
* | "This partner does not exist." |
*
* @param {Partnersnotfound2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersnotfound2 = /** @type {((inputs?: Partnersnotfound2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersnotfound2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersnotfound2(inputs)
	return de_partnersnotfound2(inputs)
});
export { partnersnotfound2 as "partnersNotFound" }